const formProfil = [
	"",
	"muldenfoermig",
	"wannenfoermig",
	"kastenfoermig",
	"trapezfoermig",
	"kegelfoermig",
	"stumpfer_kegel",
	"sonstige"
]

export default formProfil;
